import { render, staticRenderFns } from "./CmgBagReward.vue?vue&type=template&id=1539fd2c&scoped=true&lang=pug&"
import script from "./cmg-bag-reward.ts?vue&type=script&lang=ts&"
export * from "./cmg-bag-reward.ts?vue&type=script&lang=ts&"
import style0 from "./CmgBagReward.vue?vue&type=style&index=0&id=1539fd2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1539fd2c",
  null
  
)

export default component.exports